import mainCss from "../kpmg_au_pptx_preview.module.scss";
import css from "./summary.module.scss";

type SummaryProps = {
  summary: string;
  title: string;
};

export const Summary = ({ summary, title }: SummaryProps) => (
  <>
    <strong className={mainCss.header2}>{title}</strong>
    <p className={css.summary}>{summary}</p>
  </>
);
